import React from "react";
import PropTypes from "prop-types";

import { Labeled } from "@lifepay/rc-ui-toolkit";

import { TRANSACTION_SMS_STATUSES } from "../CONSTANTS";

function SMSError(props) {
  const { status } = props;

  switch (status) {
    case TRANSACTION_SMS_STATUSES.NOT_PROCESSED: {
      return null;
    }
    case TRANSACTION_SMS_STATUSES.SENT: {
      return null;
    }
    case TRANSACTION_SMS_STATUSES.SWITCHED_OFF: {
      return null;
    }
    case TRANSACTION_SMS_STATUSES.ERROR_PROC: {
      return (
        <Labeled label={"Код SMS ошибки"} type={"red"}>
          {status}
        </Labeled>
      );
    }
    case TRANSACTION_SMS_STATUSES.ERROR_PROVIDER: {
      return (
        <Labeled label={"Код SMS ошибки"} type={"red"}>
          {status}
        </Labeled>
      );
    }
    default: {
      return (
        <Labeled label={"Код SMS ошибки"} type={"red"}>
          {String(status)}
        </Labeled>
      );
    }
  }
}

SMSError.displayName = "SMSError";

SMSError.propTypes = {
  status: PropTypes.number,
};

SMSError.defaultProps = {};

export default SMSError;



// WEBPACK FOOTER //
// ./src/components/processing/transaction/SMSError.js